import { connect } from "react-redux";
import { clearAnnotation } from "../actions";
import { AnnotationTextArea, AnnotationTextAreaProps } from "../components/ImageAnnotationsTextArea";
import { AnnotationsPartialState } from "../reducers/dtos";
import { getAnnotation } from "../selectors";

const mapStateToProps = (
    state: AnnotationsPartialState,
    props: Partial<AnnotationTextAreaProps>
): Partial<AnnotationTextAreaProps> => ({
    annotation: getAnnotation(state),
});

const mapDispatchToProps: Partial<AnnotationTextAreaProps> = {
    onCancel: clearAnnotation,
};

export const AnnotationTextAreaContainer = connect(mapStateToProps, mapDispatchToProps)(AnnotationTextArea);
